<template>
    <div class="layout-sidebar-right" style="width:350px;" :class="{ 'layout-sidebar-right-active': rightMenuActive }" @click="rightMenuClick">
        <h5>Navigation History</h5>
        <Button label="Go Back" icon="pi pi-arrow-left" style="width:330px;" @click="goBack"></Button>
        <br/>
        <Menu id="overlay_menu" ref="menu" :model="navigationHistory" style="width:330px;" />
    </div>
</template>

<script>
export default {
    name: "AppRightMenu",
    emits: ["right-menu-click"],
    props: {
        rightMenuActive: Boolean,
    },
    data() {
        return {
        };
    },
    mounted() {},
    methods: {
        rightMenuClick($event) {
            this.$emit("right-menu-click", $event)
        },
        goBack(){
            this.$router.back();
        }
    },
    computed: {
        navigationHistory(){
            let data = [];
            let history = this.$store.state.security.navigationHistory;

            for(let i=0; i<history.length; i++){
                data.push({
                    label: this.$t(history[i].title),
                    to: history[i].href.replace('#','')
                })
            }

            return data;
        }
    },
};
</script>